import { render, staticRenderFns } from "./chanpindoc.vue?vue&type=template&id=53d35f19&scoped=true"
import script from "./chanpindoc.vue?vue&type=script&lang=js"
export * from "./chanpindoc.vue?vue&type=script&lang=js"
import style0 from "./chanpindoc.vue?vue&type=style&index=0&id=53d35f19&prod&scoped=true&lang=css"
import style1 from "./chanpindoc.vue?vue&type=style&index=1&id=53d35f19&prod&lang=css"
import style2 from "./chanpindoc.vue?vue&type=style&index=2&id=53d35f19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d35f19",
  null
  
)

export default component.exports